import { Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FlowItemModel } from '../../../shared/models/FlowItemModel';
import moment from 'moment';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-note-tight',
  imports: [ MatIconModule, DatePipe, RouterModule],
  templateUrl: './note-tight.component.html',
  styleUrl: './note-tight.component.css'
})
export class NoteTightComponent {
  note = input<FlowItemModel>();
  readonly dialog = inject(MatDialog);

      getTimeAgo(){
        var language = localStorage.getItem("language");
        moment.locale(language?.substring(0,2) ?? 'en');
        return moment(this.note()?.DateCreated).fromNow();
      }

  openNoteDetails() {
   /*  const dialogRef = this.dialog.open(ReportDetailsDialogComponent, {
      width: '100vw',
      height: '100vh',
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
    }); */
  }

}
